import type { ImageConversationItem } from '@/components/ai-image-assistant/types';
import { readTrimmedString } from '@/lib/prop-utils';

export function imageUploadSubject(
  image: Pick<ImageConversationItem, 'rootPrompt' | 'prompt'>,
): string {
  return readTrimmedString(image.rootPrompt) ?? readTrimmedString(image.prompt) ?? '';
}

export function buildAiGeneratedAssetUploadParams(imageUrl: string, subject: string) {
  return {
    url: imageUrl,
    source: 'ai_generated' as const,
    subject,
    // biome-ignore lint/style/useNamingConvention: Rails API param
    section_type: 'generic',
  };
}
